'use client'

import { useEffect } from 'react'

export default function UnregisterSW() {
  useEffect(() => {
    const isUiOnly = process.env.NEXT_PUBLIC_MOBILE_UI_ONLY === 'true'
    if (!isUiOnly) return
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations?.().then((regs) => {
        regs.forEach((reg) => reg.unregister().catch(() => {}))
      }).catch(() => {})
    }
  }, [])
  return null
}


